
import { Host } from '../../../Host';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { Colors } from '../../../ui';
import { EffectDirector, Effects } from '../../canvas/visualization/EffectDirector';
import { Sticky } from '../paper/Sticky';

const debugCommand = defineCommand(
    'debugTest',
    'Debug: Test',
    cc => {

        const objects = cc.resolve(ObjectManager);
        const effects = cc.resolve(EffectDirector);
        const all = Array.from(objects.getAll(Sticky));

        // for (const elmt of all) {
        //     const pt = elmt.layout?.assignment?.frame?.pointAt(.5, 0).add([0, -10]);
        //     if (!pt) continue;
        //     effects.send(Effects.text('DONE', pt, Colors.positive), elmt);
        //     effects.trigger(Effects.text('DONE', pt, Colors.positive), elmt);
        // }

        for (const elmt of all) {
            const hit = Object.keys(elmt.layout?.tags ?? {}).find(x => x.includes('/'));
            if (!hit) continue;

            const rect = elmt.layout?.tags[hit];
            effects.trigger(Effects.flash(rect, Colors.red500), elmt);

        }
    }
);

export const inDevCommands = () => inCommands(
    ...(Host.env === 'local' ? [debugCommand] : [])
);
